import * as d3 from 'd3';
import tooltip from 'd3-tip';
import { wrapText } from '../../../utils/helper';
import {
  GetChartData,
  getNoDataFoundLabel
} from '../../../utils/graph_service';

function groupBarChartUtility (
  chartConfig,
  divId,
  onDrillDown,
  drillDownConfig,
  level,
  allowDrillDown
) {
  const chartNode = document.getElementById(divId);
  if (!chartConfig.data || !chartNode) return;
  if (chartNode !== null) {
    while (chartNode.firstChild) {
      chartNode.removeChild(chartNode.firstChild);
    }
  }

  // const margin = { top: 30, left: 20, bottom: 20, right: 10 };
  function renderBarChart (
    data,
    keys,
    colors,
    accessor,
    divId,
    yAxisLabel,
    onDrillDown,
    isDrillDown,
    type
  ) {
    // console.log(data);
    const margin = { top: 20, right: 20, bottom: 30, left: 20 };
    let width = 400 - margin.left;
    let height = 300 - margin.top - margin.bottom;
    if (chartNode.offsetWidth > width) {
      width = chartNode.offsetWidth - margin.left;
      height =
        chartNode.offsetHeight > height ? chartNode.offsetHeight - 55 : height;
    }

    let totalCount = 0;
    (data || []).forEach(function (d) {
      d.total = d3.sum(keys, (k) => +parseFloat(d[k]).toFixed(2));
      totalCount += d.total;
      return d;
    });
    if (totalCount <= 0 && drillDownConfig.currentLevel <= 1) {
      const node = document.getElementById(divId);
      node.innerHTML = 'No data available for ' + chartConfig.startDate + ' to ' + chartConfig.endDate;
      node.classList.add('no-data');
      return;
    }

    var groupKey = (groupKey = accessor);
    // var keys = stackedBarChartKeys ;
    const x0 = d3
      .scaleBand()
      .domain(data.map((d) => d[groupKey]))
      .rangeRound([margin.left, width - margin.right])
      .paddingInner(0.1);

    const x1 = d3
      .scaleBand()
      .domain(keys)
      .rangeRound([0, x0.bandwidth()])
      .padding(0.05);

    const y = d3
      .scaleLinear()
      .domain([
        0,
        d3.max(data, (d) => d3.max(keys, (key) => parseFloat(d[key]).toFixed(2)))
      ])
      .nice()
      .rangeRound([height - margin.bottom, margin.top]);

    const color = d3.scaleOrdinal().range(colors);

    const svg = d3
      .select('#' + divId)
      .append('svg')
      // .attr("width", width + margin.left + "px")
      // .attr("height", height + margin.top + margin.right + margin.bottom + "px")
      // .append("g")
      .attr('viewBox', [0, 0, width + margin.right + margin.right, (height + margin.top + margin.right + margin.bottom)])
      // .attr('viewBox','0 0 '+Math.min(width,height) +' '+Math.min(width,height) )
      .attr('preserveAspectRatio', 'xMinYMin')
      .append('g')
      .attr(
        'transform',
        'translate(' + (margin.top + margin.left) + ',' + (10) + ')'
      );
    // getYAxisLabel(yAxisLabel, svg, -15, 0 - height / 2);
    document.querySelectorAll('.tooltip' + divId).forEach(function (a) {
      a.remove();
    });

    const tip = tooltip()
      .attr('class', 'd3-tip tooltip' + divId)
      .html(function (d) {
        return (
          d.key +
          ' : ' +
          parseInt(d.value).toLocaleString() +
          ((chartConfig.unit || '') === null ? '' : chartConfig.unit || '')
        ); // count
      });
    svg.call(tip);
    svg
      .append('g')
      .selectAll('g')
      .data(data)
      .join('g')
      .attr('transform', (d) => `translate(${x0(d[groupKey])},0)`)
      .selectAll('rect')
      .data(function (d) {
        // console.log("my", d);
        return keys.map((key) => ({
          key,
          value: d[key],
          accessor: d[groupKey],
          seriesItem: d.seriesItem
        }));
      })
      .join('rect')
      .attr('x', (d) => x1(d.key))
      .attr('y', (d) => y(d.value))
      .attr('width', x1.bandwidth())
      .attr('height', (d) => y(0) - y(d.value))
      .attr('fill', (d) => color(d.key) || colors[d.key])
      .attr('class', 'rect-bar')
      .style('cursor', 'pointer')
      .on('mouseover', tip.show)
      .on('mouseout', tip.hide)
      .on('click', function (d) {
        // alert(d.key + d[groupKey]);
        tip.hide(this);
        type = 'Month';
        if ((chartConfig.widgetconfig || {}).isForPerformance === true) {
          level = drillDownConfig.currentLevel;
          type =
            (
              drillDownConfig.config.find(
                (x) => x.level === drillDownConfig.currentLevel
              ) || {}
            ).type === 'YTD'
              ? 'Month'
              : 'Day';
        }
        // console.log(d);
        onDrillDown(true, d.key, type, d.accessor, level + 1, d.seriesItem,
            (d.data || {}).keyTitle);
      });

    if (totalCount === 0) {
      getNoDataFoundLabel(
        chartConfig.startDate + ' to ' + chartConfig.endDate,
        svg,
        height / 2,
        width / 2
      );
    }
    if (divId === 'MonthToDate' || divId === 'YearToDate') {
      svg
        .append('g')
        .attr('class', 'bottom-row')
        .attr('transform', `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(x0).tickSizeOuter(0))
        .selectAll('text')
        .call(wrapText, x0.bandwidth())
        .style('text-anchor', 'revert')
        .style('font-family', 'roboto')
        .style('font-weight', '500')
        .style('font-size', '10px')
        .attr('transform', 'rotate(0)');
    } else {
      svg.append('g').call((g) =>
        g
          .attr('transform', `translate(0,${height - margin.bottom})`)
          .attr('class', 'bottom-row')
          .call(d3.axisBottom(x0).tickSizeOuter(0))
          .selectAll('.tick text')
          .attr('transform', `rotate( ${data.length > 5 ? -45 : 0})`)
          .html('')
          .append('tspan')
          .text(function (d) {
            return d;
          })
          .attr('x', `${data.length > 5 ? -10 : 0}`)
          .style('text-anchor', `${data.length > 5 ? 'end' : 'middle'}`)
          .call((g) => g.select('.domain').remove())
      );
    }

    svg
      .append('g')
      .attr('transform', `translate(${margin.left},0)`)
      .attr('class', 'y-axis')
      .style('color', '#000000')
      .style('font-family', 'roboto')
      .style('font-weight', '500')
      .style('font-size', '10px')
      .call(d3.axisLeft(y).ticks(null, 's'))
      .call((g) => g.select('.domain').style('color', '#252525'));

    if (drillDownConfig.currentLevel > 1) {
      let type = 'Month';
      if ((chartConfig.widgetconfig || {}).isForPerformance === true) {
        level = drillDownConfig.currentLevel;
        type = 'YTD';
        allowDrillDown = true;
      }
      svg
        .append('svg')
        .style('fill', '#07406d')
        .style('cursor', 'pointer')
        .attr('y', -10)
        .attr('x', -10)
        .append('path')
        .attr(
          'd',
          'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
        )
        .on('click', function (d) {
          // alert("jj");
          onDrillDown(false, drillDownConfig.key, type, '', level);
        });
    }

    svg
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', -(margin.left + 10))
      .attr('x', 0 - height / 2)
      .attr('dy', '1em')
      .style('text-anchor', 'middle')
      .style('font-family', 'Roboto')
      .style('font-size', '10px')
      .style('font-weight', '500')
      .style('fill', '#000000')
      .text(yAxisLabel || 'count');

    let legendline = 10;
    let currentX = 0;
    const legend = svg
      .append('g')
      .attr('class', 'legend-container')
      .attr('width', width)
      .attr('class', 'bottom-row')
      .attr(
        'transform',
        'translate(' +
          20 +
          ', ' +
          (height - margin.bottom + margin.left + 20) +
          ')'
      );
    legend
      .selectAll('g')
      .data(keys)
      .enter()
      .append('g')
      .each(function (d, i) {
        const g = d3.select(this);
        let y = legendline;
        const rect = g
          .append('rect')
          .attr('y', y)
          .attr('x', currentX)
          .attr('width', 10)
          .attr('height', 10)
          .attr('class', d?.replace(/[^a-zA-Z0-9]/g, '') + ' legend')
          .style('fill', color(i));
        const size = rect.node().getBBox();
        currentX += size.width + 10;
        if (currentX > width) {
          currentX = 0;
          legendline += 20;
          y = legendline;
          rect.attr('x', currentX).attr('y', y);
          currentX += size.width + 10;
        }
        const recText = g
          .append('text')
          .attr('y', y + 10)
          .attr('x', currentX)
          .attr('height', 30)
          .attr('width', 170)
          .attr('class', d?.replace(/[^a-zA-Z0-9]/g, '') + ' legend')
          .style('fill', color(i))
          .style('font-family', 'roboto')
          .style('font-weight', '500')
          .style('font-size', '12px')
          .text(d);

        const recTextsize = recText.node().getBBox();
        currentX += recTextsize.width + 20;
        if (currentX > width) {
          currentX = 0;
          legendline += 20;
          y = legendline;
          rect.attr('x', currentX).attr('y', y);
          currentX += size.width + 10;
          recText.attr('x', currentX).attr('y', y + 10);
          currentX += recTextsize.width + 20;
        }
      });
  }

  RenderChart();
  function RenderChart () {
    // console.log("here", drillDownConfig.isDrillDown, drillDownConfig);
    const drillConfigData = drillDownConfig.config.find(
      (x) => x.level === level + 1
    );
    if (drillDownConfig.isDrillDown && allowDrillDown === true) {
      let config = {};
      if ((chartConfig.widgetconfig || {}).isForPerformance !== true) {
        let resData = {};

        const dirllDownColumnsConfig = { ...chartConfig.configuration };
        const filters = [];
        if (chartConfig.configuration.isRepeated === true) {
          filters.push({
            key: chartConfig.configuration.autoGenerate.key,
            values: [
              drillDownConfig.config.find((x) => x.level === level + 1).key
            ]
          });
          dirllDownColumnsConfig.autoGenerate.filters = filters;
        } else {
          dirllDownColumnsConfig.columns = [
            chartConfig.configuration.columns.find(
              (x) =>
                x.name ===
                [drillDownConfig.config.find((b) => b.level === level + 1).key]
            )
          ];
        }

        resData = GetChartData(
          chartConfig.rawData,
          dirllDownColumnsConfig,
          drillConfigData.seriesItem.start,
          drillConfigData.seriesItem.end,
          drillConfigData.type
        );

        config = {
          startDate: chartConfig.startDate,
          endDate: chartConfig.endDate,
          configuration: dirllDownColumnsConfig,
          rawData: chartConfig.rawData,
          data: resData.data,
          yAxisLabel: chartConfig.yAxisLabel,
          type: 'GroupBarChart',
          keys: resData.barKeys,
          colors: resData.barColors,
          accessor: resData.chartAccessor.mainAccessor
        };
        if (drillDownConfig.currentLevel === level + 1) {
          drillDownConfig.isDrillDown = false;
        }
        groupBarChartUtility(
          config,
          divId,
          onDrillDown,
          drillDownConfig,
          level + 1,
          allowDrillDown
        );
      } else {
        config = drillConfigData.performanceConfig;
        renderBarChart(
          config.data,
          config.keys,
          config.colors,
          config.accessor,
          divId,
          config.yAxisLabel,
          onDrillDown,
          drillDownConfig.isDrillDown,
          (drillConfigData || {}).type
        );
      }
    } else {
      renderBarChart(
        chartConfig.data,
        chartConfig.keys,
        chartConfig.colors,
        chartConfig.accessor,
        divId,
        chartConfig.yAxisLabel,
        onDrillDown,
        drillDownConfig.isDrillDown,
        (drillConfigData || {}).type
      );
    }
  }
}

export { groupBarChartUtility };
